import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateAvaliacaoFornecedorUseCase } from "../../../presentation/useCases/create/create_avaliacao_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateAvaliacaoFornecedorUseCase
 */

export class CreateAvaliacaoFornecedorUseCase implements ICreateAvaliacaoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createAvaliacaoFornecedor(
    fornecedores: number[],
    avaliadoPor: number,
    data: Date,
    centroCusto: number,
    nroNotaFiscal: string,
    observacao: string,
    criteriosAvaliacaoFornecedor: {
      idCriterioAvaliacaoFornecedor: number;
      nota: number;
    }[],
  ): Promise<void> {
    this.validaCriteriosAvaliacaoFornecedor(observacao, criteriosAvaliacaoFornecedor);
    await this.repository.createAvaliacaoFornecedor(
      fornecedores,
      avaliadoPor,
      data,
      centroCusto,
      nroNotaFiscal,
      observacao,
      criteriosAvaliacaoFornecedor,
    );
  }

  private validaCriteriosAvaliacaoFornecedor(
    observacao: string,
    criteriosAvaliacaoFornecedor: {
      idCriterioAvaliacaoFornecedor: number;
      nota: number;
    }[],
  ) {
    for (let criterioAvaliacaoFornecedor of criteriosAvaliacaoFornecedor) {
      if (criterioAvaliacaoFornecedor.nota === 0) {
        throw new UserFriendlyError('Você deve preencher todas as notas!');
      }
      if (criterioAvaliacaoFornecedor.nota < 3) {
        if (observacao.length === 0) {
          throw new UserFriendlyError('O campo "Observação" deve ser preenchido!');
        }
      }
    }
  }
}
